var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.2vw",
    height: "1.2vw",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28613 20.9883L4.99749 21.7073L8.65128 17.6874L7.2609 22.9492L8.16627 23.2107L10.3973 14.7133L4.28613 20.9883Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91699 23.7447L10.8908 24L12.0246 18.6629L13.4647 23.911L14.3762 23.6726L12.0383 15.2046L9.91699 23.7447Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.791 23.2107L16.7658 22.9596L15.2117 17.7317L18.978 21.6266L19.6626 20.9733L13.5732 14.6957L15.791 23.2107Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0109 19.868L21.7253 19.1521L17.764 15.4417L22.9638 16.8698L23.2263 15.9558L14.8291 13.6641L21.0109 19.868Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8705 3.01406L19.1591 2.29506L15.5053 6.31494L16.8957 1.05313L15.9904 0.791681L13.7593 9.28901L19.8705 3.01406Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2273 0.25535L13.2535 -1.04904e-05L12.1197 5.33711L10.6796 0.088995L9.76807 0.327445L12.106 8.79535L14.2273 0.25535Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7395 14.2442L24.0012 13.2623L18.7318 12.0664L23.9373 10.6601L23.71 9.73651L15.3105 12.02L23.7395 14.2442Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2172 7.9992L22.9505 7.01877L17.8083 8.68741L21.5905 4.80826L20.9313 4.12861L14.8359 10.4002L23.2172 7.9992Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.89723 19.8356L2.18341 19.1191L6.14787 15.4121L0.946871 16.8356L0.685059 15.9215L9.08424 13.637L2.89723 19.8356Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.254557 14.1731L-0.00146484 13.1898L5.27495 12.0253L0.0776799 10.5879L0.310438 9.66572L8.69635 11.9994L0.254557 14.1731Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3619 0.789243L7.38704 1.04035L8.94115 6.26824L5.1749 2.37331L4.49023 3.02666L10.5796 9.30418L8.3619 0.789243Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13247 4.13285L2.41804 4.84874L6.37936 8.55912L1.17958 7.13109L0.916992 8.04504L9.31424 10.3368L3.13247 4.13285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.85bae3a6b68c9377421a71348949b0fb.svg";
export { ForwardRef as ReactComponent };